module.exports = __webpack_public_path__ + "img/dianchiReport3.29981d16.png";